module.exports = __webpack_public_path__ + "static/media/Rochester.97ca65ba.png";